<template>
  <div class="row myrow content-mb-42" v-if="$parent.$parent.rerender">
    <div
      class="col-xs-12 mycol"
      v-bind:class="{
        'has-error': $parent.$parent.checkErrorField(
          'PROJECTS',
          'LOGIC',
          'UF_FEDERAL_PRJ_ID'
        )
      }"
    >
      <select
        v-model="$parent.project.UF_FEDERAL_PRJ_ID"
        class="sel-dropdown i-main-style i-wid-29"
      >
        <option
          v-for="item in $parent.directory.sp_federal_project"
          v-bind:value="item.ID"
          v-bind:key="item.ID"
          v-text="item.NAME"
        ></option>
      </select>
      <div class="error-text">
        {{
          $parent.$parent.checkErrorText(
            "PROJECTS",
            "LOGIC",
            "UF_FEDERAL_PRJ_ID"
          )
        }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "uf_federal_project_id",
  methods: {}
};
</script>

<style scoped></style>
